import React, { useEffect, useState } from "react";
import { moment } from "../../../../../vendor";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { ilockitActions, resourcesActions, useSelector, webFEActions } from "inbooma-api";
import ShowNotification from "../../../helpers/showNotification";
import { onMessageListener } from "../../../../utils/FirebaseConfig";
import { getDocHandler, in_array } from "../../../../utils/Helper";
import ItemMobile from "../viewItems/ItemMobile";
import ItemMedium from "../viewItems/ItemMedium";
import ItemWeb from "../viewItems/ItemWeb";
import { getEnv } from "../../../../Sync";

const ResourceListItem = (props) => {
  const {
    hasResourceNbr,
    dispatch,
    resource,
    setIndex,
    _index,
    setInitialized,
    onRemoveResource,
    openResourceGPS,
    showNotification,
    index,
  } = props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const currentUrl = new URL(window.location.href);
  const [localResource, setLocalResource] = useState(resource);
  const _lockSignalSound = useSelector((state) => state["ilockit_data"].sendSignalSound);
  const _lockTheftMode = useSelector((state) => state["ilockit_data"].toggleTheft);
  const _switchLock = useSelector((state) => state["ilockit_data"].switchLock);
  const _webFE = useSelector((state) => state["web_fe_data"].webFE_items);
  const [lockPending, setLockPending] = useState(null);
  const [lockTheftPending, setLockTheftPending] = useState(null);
  const [lockSignalPending, setLockSignalPending] = useState(null);
  const [resourcePending, setResourcePending] = useState(null);
  const _patchResource = useSelector((state) => state["resources_data"].patchResource);

  /*    onMessageListener().then(payload => {
        if(typeof payload.notification !== 'undefined' && typeof payload.notification.body !== 'undefined' && payload.notification.body !== '') {
            ShowNotification(null, null, payload.notification.body);
        }
        console.log(payload);
        if(payload.data.data !== "null"){
            const obj = JSON.parse(payload.data.data);
            if(obj?.shouldAlert){
                //alert(payload.notification.body);
            }
            dispatch(webFEActions.addWebFEItem(obj));
        }
    }).catch(err => console.log('failed: ', err));*/

  useEffect(() => {
    if (_webFE !== {} && typeof _webFE.data !== "undefined" && _webFE.data.length > 0) {
      _webFE.data.map((item) => {
        if (
          (item.app === null || item.app === Biscuit.get("user.id")) &&
          item.model === "Resources" &&
          item.client_id === Number(Biscuit.get("user.client_id")) &&
          item.environment === getEnv() &&
          item.id === localResource.id
        ) {
          const clone = {};
          Object.assign(clone, localResource);
          Object.keys(item.data).map((it) => {
            if (!in_array(it, ["id", "_id"])) {
              clone[it] = item.data[it];
            }
          });
          setLocalResource(clone);
          dispatch(webFEActions.removeWebFEItemById({ id: item._id }));
        }
      });
    }
  }, [_webFE]);

  useEffect(() => {
    if (_patchResource.success === "" || !resourcePending) {
      return;
    }

    if (_patchResource.success === true) {
      let clone = { ...localResource };
      clone.status = _patchResource.data.status;
      setLocalResource(clone);
      showNotification("success", localResource.id);
    } else {
      showNotification(
        "warning",
        null,
        typeof _patchResource.data.message !== "undefined"
          ? _patchResource.data.message
          : t("could_not_be_saved_${a}", { a: t("resource") }, "capital") + " #" + localResource.id,
      );
      console.log("Failed patching reservation!");
    }
    setResourcePending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_patchResource]);

  useEffect(() => {
    if (_switchLock.success === "" || lockPending === null) {
      return;
    }

    if (_switchLock.success === true) {
      showNotification(
        "success",
        localResource.id,
        t("Command was sent successfully. Please stay patient, you`ll be notified"),
      );
    } else {
      showNotification("warning", localResource.id, _switchLock.data.message);
    }
    setLockPending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_switchLock]);

  const getName = () => {
    let target = "";
    if (localResource.resource_nbr !== "" && localResource.resource_nbr !== null) {
      target += localResource.resource_nbr;
      if (localResource.name !== "" && localResource.name !== null) {
        target += " (" + localResource.name + ")";
      }
    } else if (localResource.name !== "" && localResource.name !== null) {
      target = localResource.name;
    } else {
      target = localResource.id;
    }
    return target;
  };

  useEffect(() => {
    if (_lockTheftMode.success === "" || lockTheftPending === null) {
      return;
    }

    if (_lockTheftMode.success === true) {
      let clone = {};
      Object.assign(clone, localResource);
      clone.theft = !clone.theft;
      setLocalResource(clone);
      showNotification("success", localResource.id, t("sent_theft_mode_to_${a}", { a: getName() }));
    } else {
      showNotification(
        "success",
        localResource.id,
        t("error_sending_theft_mode_to_${a}", { a: getName() }),
      );
    }
    setLockTheftPending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_lockTheftMode]);

  useEffect(() => {
    if (_lockSignalSound.success === "" || lockSignalPending === null) {
      return;
    }
    if (_lockSignalSound.success === true) {
      showNotification(
        "success",
        localResource.id,
        t("sent_signal_sound_to_${a}", { a: getName() }),
      );
    } else {
      showNotification(
        "success",
        localResource.id,
        t("error_sending_signal_sound_to_${a}", { a: getName() }),
      );
    }
    setLockSignalPending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_lockSignalSound]);

  //let act = "(" + localResource.id + ")";
  let act2 = localResource.id;
  if (hasResourceNbr) {
    // act = "";
    act2 = "";
  }
  /* if(localResource.external_resource_id !== null){
        act += " (" + localResource.external_resource_id + ")";
    }*/
  let link = "";
  // if((localResource.latitude !== null && localResource.longitude !== null) || localResource?.ilockit_device_id !== null) {
  //sub_link = "  |  ";
  link = (
    <a href="#" onClick={() => openResourceGPS(localResource)}>
      <i title={t("map", null, "capital")} className="fi fi-map map" />
    </a>
  );
  // }
  let note = "";
  if (localResource.note !== null) {
    note = localResource.note.substring(0, 100);
  }
  let countOfIcons = 0,
    countOfBigIcons = 0;
  if (localResource.lock_battery !== null) {
    countOfIcons++;
    countOfBigIcons++;
  }
  if (localResource.battery_value !== null) {
    countOfIcons++;
    countOfBigIcons++;
  }
  if (localResource.ilockit_device_id !== null) {
    countOfIcons += 2;
  }

  let iconStyle;
  let percent = 100 / countOfIcons - 1;
  if (percent < 30) {
    percent = 49;
  }
  iconStyle = {
    minWidth: percent + "%",
    height: "25px",
  };
  /*if(countOfBigIcons === 2){
        iconStyle = {minWidth:percent+"%",height:"25px"};
    }*/

  if (countOfBigIcons === 1) {
    //iconStyle = {minWidth:"33%",height:"25px"};
  }
  let blockedEnd = null,
    diff = null,
    diffString = null;
  if (localResource?.blockedEnd !== null && localResource?.diff !== null) {
    diffString = t("blocktime ends in") + " ";
    diff = localResource.diff;
    blockedEnd = moment(localResource.blockedEnd).format("DD.MM.YY HH:mm:ss");

    console.log(diff,'diff')
    let startDate = new Date();
    let endDate = new Date(localResource.blockedEnd);
    diff=(endDate.getTime() - startDate.getTime()) / 1000;
    console.log(diff,'diff')

    let days = 0,
      hours = 0,
    minutes = 0;
    if (diff >= (1440*60)) {
      days = Math.floor(diff / (1440 * 60));
      diff -= days * 1440 * 60;
    }
    if (diff >= 3600) {
      hours = Math.floor(diff / 3600);
      diff -= hours * 3600;
    }
    if (diff >= 60) {
      minutes = Math.floor(diff / 60);
      diff -= minutes * 60;
    }
    if (days > 0) {
      diffString += days + " " + t("days") + (hours > 0 || minutes > 0 || diff > 0 ? ", " : " ");
    }
    if (hours > 0) {
      diffString += hours + " " + (hours > 1 ? t("hours"): t("hour")) + (minutes > 0 || diff > 0 ? ", " : " ");
    }
    if (minutes > 0) {
      diffString += minutes + " " + (minutes > 1 ? t("minutes") : t("minute"))  + (diff > 0 ? ", " : " ");
    }
    if (diff > 0) {
      diffString += Math.floor(diff) + " " + (Math.floor(diff) > 1 ? t("seconds") : t('second')) + " ";
    }
    diffString += "(" + blockedEnd + ")";
  }
  const showContingentLocationName = false;
  const onOpen = () => {
    setIndex(_index);
  };
  let in_progress = false,
    no_station = false;
  if (localResource.checkedInStatus === "inprogress" && localResource.status === "active") {
    in_progress = true;
  }
  if (typeof localResource.location_id_name === "undefined" && localResource.status === "active") {
    no_station = true;
  }
  const location_id_name = in_progress
    ? t("inprogress")
    : no_station
      ? t("no station")
      : localResource.location_id_name;

  const onChangeStatus = (status, resource) => {
    dispatch(
      resourcesActions.patchResource({
        resource_id: resource.id,
        data: {
          status: status.target.value,
        },
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setResourcePending(resource.id);
  };

  const sendSignalSound = (resource) => {
    if (resource?.ilockit_device_id !== null) {
      dispatch(
        ilockitActions.sendSignalSound({
          //credentials: window.btoa(iLockIt_user + ':' + iLockIt_secret),          // does only work if secret has no special characters
          token: Biscuit.get("token"),
          id: resource.id,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }
    setLockSignalPending(resource);
  };

  const toggleTheft = (resource) => {
    if (resource?.ilockit_device_id !== null) {
      dispatch(
        ilockitActions.toggleTheft({
          //credentials: window.btoa(iLockIt_user + ':' + iLockIt_secret),          // does only work if secret has no special characters
          token: Biscuit.get("token"),
          id: resource.id,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
    }
    setLockTheftPending(resource.id);
  };

  const onGetQRCodeHandler = (resource, returnBlob) => {
    const url = "/resources/getQRCode/" + resource.id;
    const method = "GET";
    const id = resource.id;
    const type = "image/png";
    const filename =
      (localResource.resource_nbr != null
        ? localResource.resource_nbr
        : localResource.name != null
          ? localResource.name
          : localResource.id) + ".png";
    getDocHandler(
      url,
      method,
      type,
      filename,
      "",
      id,
      null,
      false,
      false,
      false,
      false,
      returnBlob,
    );
  };

  const switchLock = (res) => {
    if (res?.ilockit_device_id !== null) {
      let direction = res?.lock_state === "open" ? "close" : "open";
      let confirmation = window.confirm(
        t("open_lock_warnig_${a}", { a: t(direction + "_lock") }, "capital"),
      );
      if (confirmation) {
        dispatch(
          ilockitActions.switchLock({
            token: Biscuit.get("token"),
            id: res.id,
            direction: direction,
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          }),
        );
        setLockPending(res);
      }
    }
  };
  let facilityType =
    typeof localResource.facility_slots[0]?.facility?.facility_type === "undefined"
      ? null
      : localResource.facility_slots[0]?.facility?.facility_type;
  let facilityName =
    facilityType === "cyclepoint" ? localResource.facility_slots[0]?.facility?.name : null;
  let facilitySlotNbr =
    facilityType === "cyclepoint" ? localResource.facility_slots[0]?.facility_slot_nbr : null;
  if (facilityName !== null) {
    facilityName = <span>{facilityName + " Stellplatz " + facilitySlotNbr}</span>;
  }
  return (
    <>
      <ItemWeb
        localResource={localResource}
        openChangeLog={props.openChangeLog}
        hasResourceNbr={hasResourceNbr}
        showContingentLocationName={showContingentLocationName}
        location_id_name={location_id_name}
        diffString={diffString}
        key={"item_" + localResource.id + "_web"}
        setInitialized={setInitialized}
        switchLock={switchLock}
        sendSignalSound={sendSignalSound}
        toggleTheft={toggleTheft}
        countOfIcons={countOfIcons}
        iconStyle={iconStyle}
        lockPending={lockPending}
        lockSignalPending={lockSignalPending}
        lockTheftPending={lockTheftPending}
        resourcePending={resourcePending}
        onChangeStatus={onChangeStatus}
        currentUrl={currentUrl}
        onRemoveResource={onRemoveResource}
        onGetQRCodeHandler={onGetQRCodeHandler}
        act2={act2}
        note={note}
        link={link}
        index={index}
        facilityName={facilityName}
      />
      <ItemMedium
        localResource={localResource}
        hasResourceNbr={hasResourceNbr}
        showContingentLocationName={showContingentLocationName}
        location_id_name={location_id_name}
        diffString={diffString}
        key={"item_" + localResource.id + "_medium"}
        setInitialized={setInitialized}
        switchLock={switchLock}
        sendSignalSound={sendSignalSound}
        toggleTheft={toggleTheft}
        countOfIcons={countOfIcons}
        iconStyle={iconStyle}
        lockPending={lockPending}
        lockSignalPending={lockSignalPending}
        lockTheftPending={lockTheftPending}
        resourcePending={resourcePending}
        onChangeStatus={onChangeStatus}
        onRemoveResource={onRemoveResource}
        onGetQRCodeHandler={onGetQRCodeHandler}
        act2={act2}
        note={note}
        onOpen={onOpen}
        link={link}
        index={index}
        currentUrl={currentUrl}
        facilityName={facilityName}
      />
      <ItemMobile
        localResource={localResource}
        hasResourceNbr={hasResourceNbr}
        showContingentLocationName={showContingentLocationName}
        location_id_name={location_id_name}
        diffString={diffString}
        key={"item_" + localResource.id + "_mobile"}
        setInitialized={setInitialized}
        switchLock={switchLock}
        sendSignalSound={sendSignalSound}
        toggleTheft={toggleTheft}
        countOfIcons={countOfIcons}
        iconStyle={iconStyle}
        lockPending={lockPending}
        lockSignalPending={lockSignalPending}
        lockTheftPending={lockTheftPending}
        resourcePending={resourcePending}
        onChangeStatus={onChangeStatus}
        onRemoveResource={onRemoveResource}
        onGetQRCodeHandler={onGetQRCodeHandler}
        act2={act2}
        note={note}
        onOpen={onOpen}
        link={link}
        index={index}
        currentUrl={currentUrl}
        facilityName={facilityName}
      />
    </>
  );
};

export default ResourceListItem;
